// Spanish translations for ra-core and ra-supabase UI messages
export const spanishRaMessages = {
  ra: {
    action: {
      add_filter: "Añadir filtro",
      add: "Añadir",
      back: "Volver",
      bulk_actions:
        "1 elemento seleccionado |||| %{smart_count} elementos seleccionados",
      cancel: "Cancelar",
      clear_array_input: "Vaciar la lista",
      clear_input_value: "Borrar valor",
      clone: "Duplicar",
      confirm: "Confirmar",
      create: "Crear",
      create_item: "Crear %{item}",
      delete: "Eliminar",
      edit: "Editar",
      export: "Exportar",
      list: "Lista",
      refresh: "Actualizar",
      remove_filter: "Quitar este filtro",
      remove_all_filters: "Quitar todos los filtros",
      remove: "Quitar",
      reset: "Restablecer",
      save: "Guardar",
      search: "Buscar",
      search_columns: "Buscar columnas",
      select_all: "Seleccionar todo",
      select_all_button: "Seleccionar todo",
      select_row: "Seleccionar esta fila",
      show: "Ver",
      sort: "Ordenar",
      undo: "Deshacer",
      unselect: "Deseleccionar",
      expand: "Desplegar",
      close: "Cerrar",
      open_menu: "Abrir menú",
      close_menu: "Cerrar menú",
      update: "Actualizar",
      move_up: "Subir",
      move_down: "Bajar",
      open: "Abrir",
      toggle_theme: "Cambiar modo claro/oscuro",
      select_columns: "Columnas",
      update_application: "Recargar la aplicación",
    },
    boolean: {
      true: "Sí",
      false: "No",
      null: " ",
    },
    page: {
      create: "Crear %{name}",
      dashboard: "Inicio",
      edit: "%{name} %{recordRepresentation}",
      error: "Algo ha ido mal",
      list: "%{name}",
      loading: "Cargando",
      not_found: "No encontrado",
      show: "%{name} %{recordRepresentation}",
      empty: "Todavía no hay %{name}.",
      invite: "¿Quieres añadir uno?",
      access_denied: "Acceso denegado",
      authentication_error: "Error de autenticación",
    },
    input: {
      file: {
        upload_several:
          "Arrastra archivos para subirlos o haz clic para elegir uno.",
        upload_single:
          "Arrastra un archivo para subirlo o haz clic para elegirlo.",
      },
      image: {
        upload_several:
          "Arrastra imágenes para subirlas o haz clic para elegir una.",
        upload_single:
          "Arrastra una imagen para subirla o haz clic para elegirla.",
      },
      references: {
        all_missing: "No se encuentran los datos relacionados.",
        many_missing:
          "Al menos uno de los elementos relacionados ya no está disponible.",
        single_missing: "El elemento relacionado ya no está disponible.",
      },
      password: {
        toggle_visible: "Ocultar contraseña",
        toggle_hidden: "Mostrar contraseña",
      },
    },
    message: {
      about: "Acerca de",
      access_denied: "No tienes permiso para acceder a esta página",
      are_you_sure: "¿Seguro?",
      authentication_error:
        "El servidor de autenticación ha devuelto un error y no se han podido comprobar tus credenciales.",
      auth_error: "Ha habido un error al validar la sesión.",
      bulk_delete_content:
        "¿Seguro que quieres eliminar este %{name}? |||| ¿Seguro que quieres eliminar estos %{smart_count} elementos?",
      bulk_delete_title:
        "Eliminar %{name} |||| Eliminar %{smart_count} %{name}",
      bulk_update_content:
        "¿Seguro que quieres actualizar %{name} %{recordRepresentation}? |||| ¿Seguro que quieres actualizar estos %{smart_count} elementos?",
      bulk_update_title:
        "Actualizar %{name} %{recordRepresentation} |||| Actualizar %{smart_count} %{name}",
      clear_array_input: "¿Seguro que quieres vaciar toda la lista?",
      delete_content: "¿Seguro que quieres eliminar este %{name}?",
      delete_title: "Eliminar %{name} %{recordRepresentation}",
      details: "Detalles",
      error: "Ha ocurrido un error y no se ha podido completar la petición.",
      invalid_form: "El formulario no es válido. Revisa los errores",
      loading: "Un momento, por favor",
      no: "No",
      not_found: "La dirección no es correcta o el enlace está roto.",
      select_all_limit_reached:
        "Hay demasiados elementos para seleccionarlos todos. Solo se han seleccionado los primeros %{max}.",
      unsaved_changes:
        "Hay cambios sin guardar. ¿Seguro que quieres descartarlos?",
      yes: "Sí",
      placeholder_data_warning:
        "Problema de red: no se han podido actualizar los datos.",
    },
    navigation: {
      clear_filters: "Quitar filtros",
      no_filtered_results: "No hay %{name} con los filtros actuales.",
      no_results: "No hay %{name}",
      no_more_results: "La página %{page} no existe. Prueba con la anterior.",
      page_out_of_boundaries: "La página %{page} no existe",
      page_out_from_end: "No hay más páginas",
      page_out_from_begin: "No se puede ir antes de la página 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} de más de %{offsetEnd}",
      current_page: "Página %{page}",
      page: "Ir a la página %{page}",
      first: "Ir a la primera página",
      last: "Ir a la última página",
      next: "Página siguiente",
      previous: "Página anterior",
      page_rows_per_page: "Filas por página:",
      skip_nav: "Saltar al contenido",
    },
    sort: {
      sort_by: "Ordenar por %{field_lower_first} %{order}",
      ASC: "ascendente",
      DESC: "descendente",
    },
    auth: {
      auth_check_error: "Inicia sesión para continuar",
      user_menu: "Perfil",
      username: "Usuario",
      password: "Contraseña",
      email: "Email",
      sign_in: "Entrar",
      sign_in_error: "No se ha podido iniciar sesión, inténtalo de nuevo",
      logout: "Cerrar sesión",
    },
    notification: {
      updated:
        "Elemento actualizado |||| %{smart_count} elementos actualizados",
      created: "Elemento creado",
      deleted: "Elemento eliminado |||| %{smart_count} elementos eliminados",
      bad_item: "Elemento incorrecto",
      item_doesnt_exist: "El elemento no existe",
      http_error: "Error de comunicación con el servidor",
      data_provider_error:
        "Error de datos. Revisa la consola para más detalles.",
      i18n_error: "No se han podido cargar las traducciones del idioma elegido",
      canceled: "Acción cancelada",
      logged_out: "Tu sesión ha caducado, vuelve a entrar.",
      not_authorized: "No tienes permiso para acceder a este recurso.",
      application_update_available: "Hay una versión nueva disponible.",
      offline: "Sin conexión. No se han podido cargar los datos.",
    },
    validation: {
      required: "Obligatorio",
      minLength: "Debe tener al menos %{min} caracteres",
      maxLength: "Debe tener como máximo %{max} caracteres",
      minValue: "Debe ser como mínimo %{min}",
      maxValue: "Debe ser como máximo %{max}",
      number: "Debe ser un número",
      email: "Debe ser un email válido",
      oneOf: "Debe ser uno de: %{options}",
      regex: "Debe tener un formato concreto (regexp): %{pattern}",
      unique: "Debe ser único",
    },
    saved_queries: {
      label: "Búsquedas guardadas",
      query_name: "Nombre de la búsqueda",
      new_label: "Guardar búsqueda actual...",
      new_dialog_title: "Guardar búsqueda actual como",
      remove_label: "Quitar búsqueda guardada",
      remove_label_with_name: 'Quitar búsqueda "%{name}"',
      remove_dialog_title: "¿Quitar búsqueda guardada?",
      remove_message: "¿Seguro que quieres quitar esta búsqueda de tu lista?",
      help: "Filtra la lista y guarda la búsqueda para más tarde",
    },
    guesser: {
      empty: {
        title: "No hay datos que mostrar",
        message: "Revisa el proveedor de datos",
      },
    },
    configurable: {
      customize: "Personalizar",
      configureMode: "Configurar esta página",
      inspector: {
        title: "Inspector",
        content: "Pasa el ratón por los elementos para configurarlos",
        reset: "Restablecer ajustes",
        hideAll: "Ocultar todo",
        showAll: "Mostrar todo",
      },
      Datagrid: {
        title: "Tabla",
        unlabeled: "Columna sin nombre #%{column}",
      },
      SimpleForm: {
        title: "Formulario",
        unlabeled: "Campo sin nombre #%{input}",
      },
      SimpleList: {
        title: "Lista",
        primaryText: "Texto principal",
        secondaryText: "Texto secundario",
        tertiaryText: "Texto terciario",
      },
    },
  },
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Confirmar contraseña",
      sign_in_with: "Entrar con %{provider}",
      forgot_password: "¿Has olvidado la contraseña?",
      reset_password: "Restablecer contraseña",
      password_reset:
        "Revisa tu email: te hemos enviado un enlace para restablecer la contraseña.",
      missing_tokens: "Faltan los tokens de acceso",
      back_to_login: "Volver al inicio de sesión",
    },
    reset_password: {
      forgot_password: "¿Has olvidado la contraseña?",
      forgot_password_details:
        "Escribe tu email y te enviamos las instrucciones.",
    },
    set_password: {
      new_password: "Elige tu contraseña",
    },
    validation: {
      password_mismatch: "Las contraseñas no coinciden",
    },
    oauth: {
      authorize: "Autorizar aplicación",
      authorize_details: "Esta aplicación quiere acceder a tu cuenta.",
      access_scope:
        "Podrá leer y modificar tus datos, con los mismos permisos que tu cuenta.",
      approved: "Autorización concedida",
      close_tab: "Ya puedes cerrar esta pestaña.",
      no_request: "No hay ninguna solicitud de autorización",
    },
  },
};
